import React from 'react'

/**
 * Affiche un texte tronqué (ellipsis) avec un tooltip sous la cellule au survol.
 * Responsabilité: standardiser l'UX de débordement texte dans les tableaux de profils.
 */
export const TruncatedCell: React.FC<{
  value: string | null | undefined
  className?: string
}> = ({ value, className }) => {
  const normalized = (value ?? '').toString()
  const trimmed = normalized.trim()
  const tooltip = trimmed === '' ? '-' : trimmed

  return (
    <span
      className={`profile-cell-truncate profile-cell-tooltip ${className ?? ''}`}
      data-tooltip={tooltip}
    >
      {tooltip}
    </span>
  )
}
